'use client';

import { createContext, use } from 'react';

import type { GetProjectQuery } from '@/survey-graphql';

import type { UsabilityResponseSession } from './project-usability-response-session.hooks';
import type { UsabilityResponseStage } from './project-usability-response-stage.hooks';
import type { UsabilityResponseVoice } from './project-usability-response-voice.hooks';

export interface UsabilityResponseContextValue {
  project: GetProjectQuery['project'];
  session: UsabilityResponseSession;
  voice: UsabilityResponseVoice;
  stage: UsabilityResponseStage;
  conversationOverText: string | null;
}

export const UsabilityResponseContext =
  createContext<UsabilityResponseContextValue | null>(null);

export function useUsabilityResponseContext() {
  const ctx = use(UsabilityResponseContext);
  if (!ctx) {
    throw new Error(
      'Usability response sections must be used inside <ProjectUsabilityResponse>'
    );
  }
  return ctx;
}
